import { ActionHandler } from "@/components/UI/tools";
import { ArrowLeft } from "@/components/UI/svgs";
import { GallerySection, Specimen, noop } from "../galleryKit";

export const AreaSection = () => (
    <GallerySection
        id="areas"
        title="Feature areas"
        intro="Classes that only make sense inside one feature (chat.css, workspace.css, admin.css). Before adding one, check that no shared class above fits; promote it once a second feature needs it."
    >
        <Specimen
            name="Workspace text"
            classes={["editable-text", "help-text", "summary-text"]}
            usage="editable-text: read-only text that opens its editor on click (person preferences). help-text: instructions above an editor. summary-text: status preview on a dashboard widget."
            demo={() => (
                <div className="flex flex-col gap-[.5rem] max-w-[36rem]">
                    <p className="editable-text">Click to edit this text.</p>
                    <p className="help-text">Explanatory paragraph that tells the user how the editor below works.</p>
                    <p className="summary-text">Widget status preview</p>
                </div>
            )}
        />
        <Specimen
            name="Admin tools"
            classes={["suite-switcher", "admin-heading", "admin-note", "admin-disclosure", "turn-tool-output"]}
            usage="Dense internal tools (evaluation, test labs). The page title doubles as a suite switcher; notes and disclosures are monospace."
            demo={() => (
                <div className="flex flex-col gap-[.5rem] max-w-[36rem]">
                    <select className="suite-switcher w-fit" defaultValue="a">
                        <option value="a">Suite one</option>
                        <option value="b">Suite two</option>
                    </select>
                    <p className="admin-heading">Detail heading</p>
                    <p className="admin-note">Monospace helper note.</p>
                    <details>
                        <summary className="admin-disclosure">Collapsible block</summary>
                        <div className="turn-tool-output mt-[.35rem]">tool output…</div>
                    </details>
                </div>
            )}
        />
        <Specimen
            name="Chat details"
            classes={["ghost-action-mono", "tool-thinking", "composer-content", "composer-icon", "attachment-note", "timeline-rail-right", "reset-swatch", "edge-toggle-chevron", "edge-toggle-chevron-flipped", "editor-tab-focused", "editor-tab-focused-selected", "editor-tab-step"]}
            usage="Named parts of the chat components that aren't reusable outside the chat."
            demo={() => (
                <div className="flex flex-col gap-[.5rem] max-w-[36rem]">
                    <span className="ghost-action ghost-action-mono !opacity-60">copy snapshot</span>
                    <span className="tool-thinking">Streamed reasoning under a running tool…</span>
                    <span className="attachment-note">Will send after upload</span>
                    <div className="timeline-rail-right h-2 w-[8rem]" />
                    <div className="flex flex-row items-center gap-1">
                        <span className="reset-swatch" />
                        <span className="edge-toggle-chevron"><ArrowLeft /></span>
                        <span className="edge-toggle-chevron edge-toggle-chevron-flipped"><ArrowLeft /></span>
                    </div>
                    <div className="flex flex-row">
                        <ActionHandler funq={noop} className="btn-ghost editor-tab-focused">Focused</ActionHandler>
                        <ActionHandler funq={noop} selected className="btn-ghost editor-tab-focused-selected">Focused + selected</ActionHandler>
                        <ActionHandler funq={noop} className="btn-ghost"><span className="editor-tab-step">‹</span>Tab<span className="editor-tab-step">›</span></ActionHandler>
                    </div>
                </div>
            )}
        />
    </GallerySection>
);
